/**
 * Suddivisione della serie in tratti contigui per fonte, per la linea colorata
 * del grafico (SPEC-016 §4.2). File separato da `PriceChart.tsx`: un file che
 * esporta sia componenti sia funzioni rompe il Fast Refresh di Vite (stessa
 * ragione di `analysis-rating.ts`).
 */

import type { SeriesPoint } from './api';

/** Tratti contigui della stessa fonte, con il punto di confine ripetuto per non spezzare la linea. */
export function splitBySource(points: SeriesPoint[]): Array<{ source: string; points: SeriesPoint[] }> {
  const runs: Array<{ source: string; points: SeriesPoint[] }> = [];
  for (const point of points) {
    const current = runs.at(-1);
    if (current && current.source === point.source) {
      current.points.push(point);
    } else {
      const boundary = current?.points.at(-1);
      runs.push({ source: point.source, points: boundary ? [boundary, point] : [point] });
    }
  }
  return runs;
}
